import { Button, Grid, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import MergeIcon from '@mui/icons-material/Merge';
import DisplayEmptyListAction from "../../../../../../../components/DisplayEmptyListAction";
import { DetalheTituloRebcInfoFiscal, Publico } from "../../../../../../../types/api/financeiro/datalhar-titulos-receber";
import { formatarValorMonetario } from "../../../../../../../helpers/masks";
import tratativaDeDatas from "../../../../../../../helpers/tratativaDeDatas";
import { verificarStringVazia } from "../../../../../../../helpers/verificadores";
import { useState } from "react";
import DialogSelectMovFiscaisSaída from "./DialogSelectMovFiscaisSaída";

export default function NotaFiscal({
    valores,
    publico,
    titulo
}: NotaFiscalProps) {

    const [openSelect, setOpenSelect] = useState<boolean>(false)

    //funçoes manipuladoras
    //

    //valores importantes
    const paddingStyle = { paddingLeft: 0, paddingRight: 0 }

    const Actions = () => (
        <Stack direction="row" gap={2}>
            <Button
                variant="outlined"
                size="small"
                startIcon={<MergeIcon />}
                onClick={() => setOpenSelect(true)}
            >
                Vincular existente
            </Button>
        </Stack>
    )
    //

    return (
        <>
            {
                !valores &&
                <>
                    <DisplayEmptyListAction
                        label="Nenhuma nota fiscal vinculada a esse título. Deseja vincular?"
                        actionSection={<Actions />}
                    />
                    {
                        openSelect &&
                        <DialogSelectMovFiscaisSaída
                            {...{ publico, titulo }}
                            open={openSelect}
                            handleClose={() => setOpenSelect(false)}
                        />
                    }
                </>
            }

            {
                valores &&
                <>
                    <Grid container rowGap={2}>
                        <Grid size={{xs: 6}}>
                            <NotaFiscalLabelPrinter label="Fazenda" valor={verificarStringVazia(valores.informacoes_venda.fazenda)} />
                        </Grid>

                        <Grid size={{xs: 6, md: 3}}>
                            <NotaFiscalLabelPrinter label="Espécie" valor={valores.especie_documento} />
                        </Grid>

                        <Grid size={{xs: 6, md: 3}}>
                            <NotaFiscalLabelPrinter label="Nº documento" valor={valores.numero_documento} />
                        </Grid>

                        <Grid size={{xs: 6, md: 3}}>
                            <NotaFiscalLabelPrinter label="Série" valor={valores.serie_documento} />
                        </Grid>

                        <Grid size={{xs: 6, md: 3}}>
                            <NotaFiscalLabelPrinter label="UF" valor={valores.uf_documento} />
                        </Grid>

                        <Grid size={{xs: 6, md: 3}}>
                            <NotaFiscalLabelPrinter label="Data do documento" valor={tratativaDeDatas(valores.data_documento)} />
                        </Grid>

                        <Grid size={{xs: 6, md: 3}}>
                            <NotaFiscalLabelPrinter label="Valor contábil" valor={formatarValorMonetario(valores.valor_contabil)} />
                        </Grid>

                        <Grid size={{xs: 6, md: 3}}>
                            <NotaFiscalLabelPrinter label="Valor pauta" valor={formatarValorMonetario(valores.valor_pauta)} />
                        </Grid>

                        <Grid size={{xs: 6, md: 3}}>
                            <NotaFiscalLabelPrinter label="Valor ICMS ST" valor={formatarValorMonetario(valores.icms_st)} />
                        </Grid>

                        <Grid size={{xs: 6, md: 3}}>
                            <NotaFiscalLabelPrinter label="Frete" valor={formatarValorMonetario(valores.valor_frete)} />
                        </Grid>

                        <Grid size={{xs: 6, md: 3}}>
                            <NotaFiscalLabelPrinter label="Seguro" valor={formatarValorMonetario(valores.valor_seguro)} />
                        </Grid>

                        <Grid size={{xs: 6, md: 3}}>
                            <NotaFiscalLabelPrinter label="Outros" valor={formatarValorMonetario(valores.valor_outros)} />
                        </Grid>

                        <Grid size={{xs: 6, md: 3}}>
                            <NotaFiscalLabelPrinter label="Descontos" valor={formatarValorMonetario(valores.valor_desconto)} />
                        </Grid>

                        <Grid size={{xs: 6, md: 3}}>
                            <NotaFiscalLabelPrinter label="Retenção PIS" valor={formatarValorMonetario(valores.retencao_pis)} />
                        </Grid>

                        <Grid size={{xs: 6, md: 3}}>
                            <NotaFiscalLabelPrinter label="Retenção COFINS" valor={formatarValorMonetario(valores.retencao_cofins)} />
                        </Grid>

                        <Grid size={{xs: 6, md: 3}}>
                            <NotaFiscalLabelPrinter label="Retenção CSLL" valor={formatarValorMonetario(valores.retencao_csll)} />
                        </Grid>

                        <Grid size={{xs: 6, md: 3}}>
                            <NotaFiscalLabelPrinter label="Retenção Base IR" valor={formatarValorMonetario(valores.retencao_base_ir)} />
                        </Grid>

                        <Grid size={{xs: 6, md: 3}}>
                            <NotaFiscalLabelPrinter label="Nat. operação" valor={`${valores.natureza_operacao}`} />
                        </Grid>
                    </Grid>

                    <Typography fontWeight="bold" mb={2} variant="h6">Venda de produtos</Typography>
                    <Grid container rowGap={2}>
                        <Grid size={{xs: 6}}>
                            <NotaFiscalLabelPrinter label="Cliente" valor={`${valores.tipo_cliente || ''}${valores.codigo_cliente || ''} - ${valores.nome_cliente || ''}`} />
                        </Grid>

                        <Grid size={{xs: 6}}>
                            <NotaFiscalLabelPrinter label="Vendedor" valor={valores.informacoes_venda.vendedor} />
                        </Grid>

                        <Grid size={{xs: 12}}>
                            <TableContainer>
                                <Table size="small" aria-label="a dense table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={paddingStyle}><b>Produto</b></TableCell>
                                            <TableCell align="right"><b>Quantidade</b></TableCell>
                                            <TableCell sx={paddingStyle} align="right"><b>Valor venda</b></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {valores.informacoes_venda.produtos.map((row) => (
                                            <TableRow
                                                key={row.id}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell sx={paddingStyle} component="th" scope="row">
                                                    {row.nome}
                                                </TableCell>
                                                <TableCell align="right">{row.quantidade}</TableCell>
                                                <TableCell sx={paddingStyle} align="right">{formatarValorMonetario(row.valor_venda)}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </>
            }
        </>
    )
}

const NotaFiscalLabelPrinter = ({
    label,
    valor
}: NotaFiscalLabelPrinterProps) => {
    return (
        <Stack>
            <Typography fontWeight="bold" variant="subtitle2">{label}</Typography>
            <Typography variant="subtitle2">{valor}</Typography>
        </Stack>
    )
}

interface NotaFiscalProps {
    publico: Publico,
    titulo: string,
    valores: DetalheTituloRebcInfoFiscal | null
}

interface NotaFiscalLabelPrinterProps {
    label: string,
    valor: string
}
